import { useState } from "react";
import SectionHeader from "./SectionHeader";
import { faqs } from "@/mocks/manhwa";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <SectionHeader
            align="left"
            tag="常见问题"
            title="关于追更，你想知道的都在这里"
            desc="围绕虚空韩漫网的追更进度、连载提醒、更新周表等常见疑问，我们整理了以下解答，帮助你更快上手。"
          />
          <a
            href="#contact"
            className="inline-flex h-12 items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-chat-3-line text-base"></i>
            仍有疑问，联系我们
          </a>
        </div>

        <div className="flex flex-col gap-3 lg:col-span-2">
          {faqs.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={f.question}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  isOpen ? "border-primary-200 bg-primary-50/60" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{f.question}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`}></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6">{f.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}